// extracted by mini-css-extract-plugin
export var animation = "MobileApps-module--animation--0b107";
export var code = "MobileApps-module--code--e4e2f";
export var crashAlert = "MobileApps-module--crash-alert--07314";
export var crashText = "MobileApps-module--crash-text--d4697";
export var data = "MobileApps-module--data--088e2";
export var dom = "MobileApps-module--dom--dc18b";
export var filter = "MobileApps-module--filter--84735";
export var float = "MobileApps-module--float--1629d";
export var flow = "MobileApps-module--flow--7a6cb";
export var particles = "MobileApps-module--particles--dc1f8";
export var particlesCanvas = "MobileApps-module--particles-canvas--2f105";
export var phoneFaded = "MobileApps-module--phone-faded--ea20e";
export var privacyText = "MobileApps-module--privacy-text--4b8d7";
export var rules = "MobileApps-module--rules--83bdc";
export var scan = "MobileApps-module--scan--12db8";
export var scanLine = "MobileApps-module--scan-line--b8de5";
export var scanText = "MobileApps-module--scan-text--dfe1a";
export var sdkSquares = "MobileApps-module--sdk-squares--745f1";
export var sdkText = "MobileApps-module--sdk-text--54853";
export var secured = "MobileApps-module--secured--2722a";